import { useState } from "react";
import { motion } from "motion/react";
import { useStore } from "../lib/store.js";
import { haptic, openLink, tg } from "../lib/telegram.js";
import { socket } from "../lib/socket.js";

export function Waiting() {
  const { snapshot, inviteLink, reset } = useStore();
  const [copied, setCopied] = useState(false);

  if (!snapshot) return null;

  const share = () => {
    haptic.tap();
    if (!inviteLink) return;
    const text = `Зову на партию: ${snapshot.game === "chess" ? "шахматы" : "дурак"} ${snapshot.timeControl}`;
    // Нативный выбор чата: Telegram сам предложит, кому отправить.
    openLink(`https://t.me/share/url?url=${encodeURIComponent(inviteLink)}&text=${encodeURIComponent(text)}`);
  };

  const copy = async () => {
    if (!inviteLink) return;
    haptic.tap();
    try {
      await navigator.clipboard.writeText(inviteLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      /* буфер недоступен — остаётся кнопка «Поделиться» */
    }
  };

  return (
    <motion.div
      className="stack"
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="center" style={{ paddingTop: 24, paddingBottom: 8 }}>
        <div className="stack" style={{ alignItems: "center", gap: 16 }}>
          <motion.div
            style={{ fontSize: 56, lineHeight: 1 }}
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
          >
            {snapshot.game === "chess" ? "♞" : "🂡"}
          </motion.div>
          <div>
            <div style={{ fontSize: 19, fontWeight: 700 }}>Ждём соперника</div>
            <div className="muted small">
              {snapshot.game === "chess" ? "Шахматы" : "Дурак"} · {snapshot.timeControl}
            </div>
          </div>
          <div className="spinner" />
        </div>
      </div>

      <div className="card stack" style={{ gap: 10 }}>
        <div className="muted small">Отправь другу ссылку — партия начнётся, как только он войдёт</div>
        <div
          className="small"
          style={{
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
            background: "var(--bg)",
            border: "1px solid var(--line)",
            borderRadius: "var(--radius-sm)",
            padding: "10px 12px",
            wordBreak: "break-all",
            color: "var(--text-dim)",
          }}
        >
          {inviteLink}
        </div>
      </div>

      <button className="btn btn-primary" onClick={share}>
        Поделиться ссылкой
      </button>
      <button className="btn" onClick={copy}>
        {copied ? "Скопировано" : "Скопировать"}
      </button>
      <button
        className="btn btn-danger"
        onClick={() => {
          haptic.tap();
          socket.leaveMatch(snapshot.matchId);
          reset();
        }}
      >
        Отменить
      </button>

      {!tg && (
        <div className="muted small" style={{ textAlign: "center" }}>
          Открой приложение внутри Telegram, чтобы делиться в один клик
        </div>
      )}
    </motion.div>
  );
}
